/**
 * 公众号管理端相关的菜单管理
 */

import FinancialList from '../component/wechat/financial/FinancialList';   //财务审核
import FinancialDetail from '../component/wechat/financial/FinancialDetail'; //财务审核具体页面
import ContractIndex from '../component/wechat/contract/ContractIndex'; //财务审核具体页面

import UserInfo from '../component/wechat/common/UserInfo'; //账户信息

export default {
    WXGZH_USER: {component: UserInfo, icon: 'icon-user', url: '/wx/console/user'},   //账户信息

    WXGZH_FINANCIAL_AUDIT: {component: FinancialList, icon: 'icon-financial-audit', url: '/wx/console/financialAudit/index'}, //财务审核
    WXGZH_FINANCIAL_DETAIL: {component: FinancialDetail, icon: '', url: '/wx/console/financialAudit/detail'}, //财务审核
    WXGZH_ContractIndex: {component: ContractIndex, icon: '', url: '/wx/console/contract'}, //合同审核

}